import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Grid,
  Message,
  Container,
  Image,
  Radio,
  Divider,
} from "semantic-ui-react";
import { compose } from "redux";
import axios from "axios";
import { withRouter, Link } from "react-router-dom";
import { firebaseConnect } from "react-redux-firebase";
import { styles } from "./styles";
import {
  validateOnlyLetters,
  validateEmail,
  validatePassword,
  errorMsgs,
} from "../../commons/functions/formValidations";
import "./styles.css";
import FacebookProvider from "../Login/Facebook/FacebookProvider";
import { COUNTRIES } from "../../data/locations";

const Signup = ({ firebase, history }) => {
  const INITIAL_USER = {
    name: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    birthday: "",
    country: "",
    gender: "",
    termsAndConditions: false,
  };
  const [user, setUser] = useState(INITIAL_USER);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isValid, setIsValid] = useState({
    name: { valid: true, error: "" },
    lastName: { valid: true, error: "" },
    email: { valid: true, error: "" },
    password: { valid: true, error: "" },
    confirmPassword: { valid: true, error: "" },
    birthday: { valid: true, error: "" },
    country: { valid: true, error: "" },
    gender: { valid: true, error: "" },
  });
  const showPasswordAlert =
    user.password &&
    user.confirmPassword &&
    user.password !== user.confirmPassword;

  useEffect(() => {
    const isUser = Object.values(user).every((element) => Boolean(element));
    const isValidForm = Object.values(isValid).every((element) =>
      Boolean(element.valid)
    );
    isUser && isValidForm && user.password === user.confirmPassword
      ? setDisabled(false)
      : setDisabled(true);
  }, [user, isValid]);

  const handleChange = (e, data) => {
    if (e.target.name) {
      const { name, value } = e.target;
      setUser((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      switch (name) {
        case "name":
        case "lastName":
          validateOnlyLetters(value)
            ? validateForm(name, true, "")
            : value === ""
            ? validateForm(name, false, errorMsgs.required)
            : value.length === 1
            ? validateForm(name, false, errorMsgs.atLeastTwo)
            : validateForm(name, false, errorMsgs.lettersOnly);
          break;
        case "email":
          validateEmail(value)
            ? validateForm(name, true, "")
            : value === ""
            ? validateForm(name, false, errorMsgs.required)
            : validateForm(name, false, errorMsgs.email);
          break;
        case "password":
        case "confirmPassword":
          validatePassword(value)
            ? validateForm(name, true, "")
            : value === ""
            ? validateForm(name, false, errorMsgs.required)
            : validateForm(name, false, errorMsgs.password);
          break;
        default:
          break;
      }
    } else {
      const { name, value } = data;
      setUser((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      switch (name) {
        case "country":
          value
            ? validateForm(name, true, "")
            : validateForm(name, false, errorMsgs.required);

          break;

        default:
          break;
      }
    }
  };
  const handleToggle = () => {
    setUser((prevState) => ({
      ...prevState,
      termsAndConditions: !user.termsAndConditions,
    }));
  };

  const validateForm = (name, bool, error) => {
    setIsValid((prevState) => ({
      ...prevState,
      [name]: { valid: bool, error },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");
      const response = await firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password);
      const profile = {
        uid: response.user.uid,
        name: user.name,
        lastName: user.lastName,
        email: user.email,
        birthday: user.birthday,
        gender: user.gender,
        country: user.country,
      };
      await axios.post(
        `${process.env.REACT_APP_apiUrl}/createProfile`,
        profile
      );
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
      history.push("/");
    }
  };
  return (
    <div className="container-Sections">
      <Container className="signup-container">
        <Container text>
          <Grid className="pl-4">
            <Grid.Row centered className="mt-5">
              <Grid.Column className="col-lg-6 col-md-6 col-sm-6 col-12">
                {/* El button de facebook llevara al usuario a registrarse por medio de facebook */}
                {false && (
                  <>
                    <div className="login-with-providers">
                      <FacebookProvider history={history} />
                    </div>
                    <Divider horizontal>O</Divider>
                  </>
                )}
                <div className="mt-3 mb-4">
                  <p className="h3 text-center">Crea una cuenta</p>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column className="col-12">
                <Form
                  error={Boolean(error)}
                  onSubmit={handleSubmit}
                  loading={loading}
                >
                  <Message error header="Oops!" content={error || ""} />
                  <Form.Group widths="equal" className="mb-5">
                    <div className="signup-div-input-error">
                      <input
                        style={styles.inputStyle}
                        placeholder="Nombres"
                        name="name"
                        onChange={handleChange}
                        value={user.name}
                        type="text"
                        className="input-custom"
                      />
                      <p className="signup-input-error">
                        {!isValid.name.valid && isValid.name.error}
                      </p>
                    </div>
                    <div style={styles.separator} />
                    <div className="signup-div-input-error">
                      <input
                        style={styles.inputStyle}
                        placeholder="Apellidos"
                        name="lastName"
                        onChange={handleChange}
                        value={user.lastName}
                        type="text"
                        className="input-custom"
                      />
                      <p className="signup-input-error">
                        {!isValid.lastName.valid && isValid.lastName.error}
                      </p>
                    </div>
                  </Form.Group>

                  <Form.Group widths="equal" className="mb-5">
                    <div className="signup-div-input-error">
                      <input
                        className="input-custom"
                        placeholder="Correo"
                        name="email"
                        onChange={handleChange}
                        value={user.email}
                        type="email"
                        style={styles.inputStyle}
                      />
                      <p className="signup-input-error">
                        {!isValid.email.valid && isValid.email.error}
                      </p>
                    </div>
                    <div style={styles.separator} />
                    <div className="signup-div-input-error">
                      <input
                        title="Introduzca la fecha de su cumpleaños"
                        className="input-custom"
                        style={styles.inputStyle}
                        type="date"
                        value={user.birthday}
                        onChange={handleChange}
                        name="birthday"
                      />
                      <p className="signup-input-birthday">
                        {"*Fecha de su cumpleaños"}
                      </p>
                    </div>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <div className="signup-div-input-error">
                      <input
                        title={errorMsgs.passwordFormat}
                        className="input-custom"
                        style={styles.inputStyle}
                        placeholder="Contraseña"
                        name="password"
                        onChange={handleChange}
                        value={user.password}
                        type="password"
                      />
                      <p className="signup-input-error">
                        {!isValid.password.valid && isValid.password.error}
                      </p>
                    </div>
                    <div style={styles.separator} />
                    <div className="signup-div-input-error">
                      <input
                        title={errorMsgs.passwordFormat}
                        style={styles.inputStyle}
                        className="input-custom"
                        placeholder="Confirmar contraseña"
                        name="confirmPassword"
                        onChange={handleChange}
                        value={user.confirmPassword}
                        type="password"
                      />
                      <p className="signup-input-error">
                        {!isValid.confirmPassword.valid &&
                          isValid.confirmPassword.error}
                      </p>
                    </div>
                  </Form.Group>
                  <div className="text-center">
                    {showPasswordAlert && (
                      <p className="signup-password-error">
                        Las contraseñas no coinciden
                      </p>
                    )}
                  </div>
                  <br></br>
                  <Form.Group widths="equal">
                    <div className="signup-div-input-error">
                      <Form.Select
                        options={COUNTRIES}
                        placeholder="País"
                        className="input-custom"
                        style={styles.inputStyle}
                        name="country"
                        onChange={handleChange}
                      />
                    </div>
                    <div style={styles.separator} />
                    <div className="signup-div-input-error"></div>
                  </Form.Group>

                  <Form.Group inline className="mt-5">
                    <label className="d-flex flex-row">
                      <div className="pr-3">
                        <p className="h6 font-weight-normal">Hombre</p>
                      </div>
                      <Form.Input
                        type="radio"
                        name="gender"
                        value="male"
                        checked={user.gender === "male"}
                        onChange={handleChange}
                      />
                    </label>
                    <div style={styles.separator} />
                    <label className="d-flex flex-row">
                      <div className="pr-3">
                        <p className="h6 font-weight-normal">Mujer</p>
                      </div>
                      <Form.Input
                        type="radio"
                        name="gender"
                        value="female"
                        checked={user.gender === "female"}
                        onChange={handleChange}
                      />
                    </label>
                  </Form.Group>

                  <div style={styles.buttonSubmitContainer} className="mb-5">
                    <Radio
                      toggle
                      style={{ zIndex: 0 }}
                      onChange={handleToggle}
                    />
                    <p>
                      He leído y acepto{" "}
                      <Link to="/purchases">los términos y condiciones.</Link>
                    </p>
                  </div>
                  <div style={styles.buttonSubmitContainer} className="pb-5">
                    <Button
                      size="huge"
                      type="submit"
                      color="orange"
                      content="Crear cuenta"
                      disabled={disabled || loading}
                    />
                  </div>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
        <Image src="./assets/footer_signup.png" style={styles.rounded} />
      </Container>
    </div>
  );
};

export default compose(withRouter, firebaseConnect())(Signup);
